import React, { useState, useEffect, useRef } from 'react';
import { DEFAULT_CONFIG } from '../lib/store';

function RoundSetup({
  title,
  subtitle,
  questionValue,
  setQuestionValue,
  onStart,
  buttonLabel,
  extra,
}) {
  return (
    <div className="host-panel card-panel">
      <h3>{title}</h3>
      {subtitle ? <p className="hint">{subtitle}</p> : null}
      <label className="field">
        <span>Savol narxi</span>
        <input
          type="number"
          min="1"
          value={questionValue}
          onChange={(e) => setQuestionValue(e.target.value)}
        />
      </label>
      <p className="hint soft">
        Boshlaganda barcha ovoz navbati avtomatik tozalanadi.
      </p>
      <button
        className="btn-solid"
        disabled={!Number(questionValue) || Number(questionValue) < 1}
        onClick={onStart}
      >
        {buttonLabel}
      </button>
      {extra}
    </div>
  );
}

export default function HostPanel({
  game,
  headPlayer,
  buzzedPlayers,
  hostConfig,
  teams,
}) {
  const [questionValue, setQuestionValue] = useState(
    String(DEFAULT_CONFIG.questionValue)
  );
  const [restartScore, setRestartScore] = useState(null);
  const [restartPenalty, setRestartPenalty] = useState(null);
  const configApplied = useRef(false);

  const phase = game.G.phase;
  const question = game.G.question;

  const cfg = {
    startingScore:
      hostConfig && hostConfig.startingScore != null
        ? hostConfig.startingScore
        : game.G.config.startingScore,
    penalty:
      hostConfig && hostConfig.penalty != null
        ? hostConfig.penalty
        : game.G.config.penalty,
  };

  useEffect(() => {
    if (phase !== 'lobby' || configApplied.current) return;
    if (!hostConfig) return;
    configApplied.current = true;
    game.moves.setRoomConfig(
      Number(hostConfig.startingScore),
      Number(hostConfig.penalty)
    );
  }, [phase, hostConfig, game.moves]);

  useEffect(() => {
    if (phase === 'finished') {
      setRestartScore(String(game.G.config.startingScore));
      setRestartPenalty(String(game.G.config.penalty));
    }
  }, [phase, game.G.config.startingScore, game.G.config.penalty]);

  const doRestart = () => {
    const score = Math.floor(Number(restartScore));
    const pen = Math.floor(Number(restartPenalty));
    if (Number.isNaN(score) || score < 0 || !pen || pen < 1) return;
    if (
      !window.confirm(
        'Shu xonada yangi o‘yin? Jamoalar saqlanadi, ballar noldan boshlanadi.'
      )
    ) {
      return;
    }
    game.moves.restartMatch(score, pen);
  };

  if (phase === 'lobby') {
    return (
      <div className="host-stack">
        <div className="card-panel host-summary">
          <p className="eyebrow">Xona sozlamalari</p>
          <div className="summary-row">
            <span>Boshlang‘ich ball</span>
            <strong>{cfg.startingScore}</strong>
          </div>
          <div className="summary-row">
            <span>Jarima</span>
            <strong>−{cfg.penalty}</strong>
          </div>
          <div className="summary-row">
            <span>Jamoalar</span>
            <strong>{teams.length}</strong>
          </div>
        </div>
        <RoundSetup
          title="Birinchi savol"
          subtitle="Savol narxini belgilang va o‘yinni boshlang."
          questionValue={questionValue}
          setQuestionValue={setQuestionValue}
          buttonLabel="O‘yinni boshlash"
          onStart={() => {
            const price = Math.floor(Number(questionValue));
            if (price < 1) return;
            game.moves.startGame(
              price,
              Number(cfg.startingScore),
              Number(cfg.penalty)
            );
          }}
        />
      </div>
    );
  }

  if (phase === 'finished') {
    return (
      <div className="host-panel card-panel restart-panel">
        <h3>Yangi o‘yin</h3>
        <p className="hint">
          Jamoalar shu xonada qoladi. Ballar va navbat tozalanadi.
        </p>
        <label className="field">
          <span>Boshlang‘ich ball</span>
          <input
            type="number"
            min="0"
            value={restartScore != null ? restartScore : cfg.startingScore}
            onChange={(e) => setRestartScore(e.target.value)}
          />
        </label>
        <label className="field">
          <span>Jarima</span>
          <input
            type="number"
            min="1"
            value={restartPenalty != null ? restartPenalty : cfg.penalty}
            onChange={(e) => setRestartPenalty(e.target.value)}
          />
        </label>
        <button type="button" className="btn-solid" onClick={doRestart}>
          Qayta boshlash
        </button>
      </div>
    );
  }

  if (question.status === 'resolved') {
    return (
      <RoundSetup
        title={`Keyingi savol (#${question.number + 1})`}
        subtitle="Yangi savol narxini belgilang — ovozlar qayta ochiladi."
        questionValue={questionValue}
        setQuestionValue={setQuestionValue}
        buttonLabel="Savolni boshlash"
        onStart={() => {
          const price = Math.floor(Number(questionValue));
          if (price >= 1) game.moves.nextQuestion(price);
        }}
      />
    );
  }

  return (
    <div className="host-panel card-panel">
      <div className="host-panel-head">
        <h3>Boshqaruv</h3>
        <span className="chip">−{game.G.config.penalty} jarima</span>
      </div>

      {headPlayer ? (
        <div className="answering-box">
          <p className="answering-label">Hozir javob beryapti</p>
          <p className="answering-name">{headPlayer.name}</p>
          <div className="verdict-buttons">
            <button
              type="button"
              className="btn-correct"
              title={`To‘g‘ri (+${question.value})`}
              aria-label={`To‘g‘ri, +${question.value} ball`}
              onClick={() => game.moves.markCorrect(headPlayer.id)}
            >
              <span className="verdict-mark" aria-hidden="true">
                ✓
              </span>
              <span className="verdict-delta">+{question.value}</span>
            </button>
            <button
              type="button"
              className="btn-wrong"
              title={`Noto‘g‘ri (−${game.G.config.penalty})`}
              aria-label={`Noto‘g‘ri, −${game.G.config.penalty} ball`}
              onClick={() => game.moves.markIncorrect(headPlayer.id)}
            >
              <span className="verdict-mark" aria-hidden="true">
                ✕
              </span>
              <span className="verdict-delta">−{game.G.config.penalty}</span>
            </button>
          </div>
        </div>
      ) : (
        <p className="hint">Ovoz kutilyapti...</p>
      )}
    </div>
  );
}
